module.exports = __webpack_public_path__ + "static/Global_Slate-3befc2c647c58720e09eb6cfae94ca3d.jpg";